import { generatePath, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@treezor/design-system';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppSelector } from '@/hooks/redux-helpers';
import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { useAction } from '@/hooks/useAction';

import { selectProfileByUserId } from '@/store/selectors';

import { useProfileContext } from '@/features/context/ProfileContext';
import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { useRoutepaths } from '@/router/hooks/useRoutePaths';
import { useMatomo } from '@/features/matomo/useMatomo';
import { UserTypes } from '@/features/user/store/user.model';

export function CompanyMemberActions() {
  const { user } = useProfileContext();
  const { t } = useTranslation();
  const dashboardConfig = useDashboardConfig();
  const { displayActionFromConfig } = useAction();

  const navigate = useNavigate();
  const PathRoute = useRoutepaths();
  const { triggerEvent } = useMatomo();

  const userCreationTypes = dashboardConfig.settings.users?.creation;
  const { hasAccessToFeature } = useAccesControl();

  const isLoading = useAppSelector(
    (state) => selectProfileByUserId(state, user.userId as number)?.state?.children?.create?.isLoading,
  );

  const onAddChild = () => {
    triggerEvent('user-children', { 'user-children-action': 'start' });
    if (userCreationTypes) {
      navigate(generatePath(PathRoute.app.root, { '*': `${PathRoute.app.createUser}?parentId=${user.userId}` }));
    }
  };

  return (
    <>
      {displayActionFromConfig('addChild') && hasAccessToFeature(featuresSlugs.ADD_CHILD) && (
        <Button id="add-child-dialog-btn" isLoading={isLoading} icon="add" variant="tertiary" onClick={onAddChild}>
          {t(
            `pages.currentProfiles.actionUser.addChild.${user?.userTypeId === UserTypes.naturalPerson ? 'add' : 'addMember'}`,
          )}
        </Button>
      )}
    </>
  );
}

export default CompanyMemberActions;
